/**
 * FASE 20.2 — Events Query Adapter
 */

import { supabase }             from "../../supabase";
import { applyPermissionScope } from "../permissionFilters";

// location_name does not exist in the events table — only use confirmed columns
const EVENT_FIELDS = "id, title, date, time, event_type, church_id, district_id, type";
const MAX_ROWS     = 15;

/**
 * Events in the next N days.
 * @param {import('../permissionFilters').PermissionScope} scope
 * @param {number} [daysAhead=7]
 * @returns {Promise<Object[]>}
 */
export async function getUpcomingEvents(scope, daysAhead = 7) {
  const today    = new Date().toISOString().slice(0, 10);
  const futureTs = new Date(Date.now() + daysAhead * 24 * 60 * 60 * 1000);
  const future   = futureTs.toISOString().slice(0, 10);

  let query = supabase
    .from("events")
    .select(EVENT_FIELDS)
    .gte("date", today)
    .lte("date", future)
    .order("date", { ascending: true })
    .limit(MAX_ROWS);

  query = applyPermissionScope(query, scope);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}
